import React from 'react'

import classnames from 'classnames'
import PropTypes from 'prop-types'

import OrderSummary from 'containers/welcome/OrderSummary'
import { AppDownloadPrompt } from './AppDownloadPrompt/AppDownloadPrompt'

import { ReferAFriend } from '../OrderConfirmation/components/ReferAFriend'
import { AppPromo } from './AppPromo'
import { AwinPixelContainer } from './AwinPixel'
import { OrderSchedule } from './OrderSchedule'
import { WelcomeFirstBoxOrderWrapper } from './WelcomeFirstBoxOrderWrapper'

import css from './Welcome.css'

const propTypes = {
  device: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired,
  orderId: PropTypes.string.isRequired,
  params: PropTypes.shape({
    orderId: PropTypes.string,
  }).isRequired,
  query: PropTypes.shape({
    var: PropTypes.string,
  }).isRequired,
  trackWelcomeAppPromoClick: PropTypes.func.isRequired,
  userFetchReferralOffer: PropTypes.func.isRequired,
  addRecipeToBasket: PropTypes.func.isRequired,
  userLoadData: PropTypes.func.isRequired,
  trackAppDownloadPrompt: PropTypes.func.isRequired,
  isSignUpFirstTwoBoxesExperimentEnabled: PropTypes.bool.isRequired,
  isDownloadAppPromptExperimentEnabled: PropTypes.bool.isRequired,
}

class Welcome extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isAppDownloadPromptDisplayed: false,
    }
  }

  componentDidMount() {
    const {
      query = {},
      params = {},
      fetchData,
      addRecipeToBasket,
      userFetchReferralOffer,
      userLoadData,
      isDownloadAppPromptExperimentEnabled,
      device,
      trackAppDownloadPrompt,
    } = this.props

    userLoadData()
    userFetchReferralOffer()
    fetchData({ query, params }, addRecipeToBasket)

    const allowedDownloadAppDevices = ['mobile', 'tablet'] // TODO: Potentially refactor to UseModal Hook.
    if (isDownloadAppPromptExperimentEnabled && allowedDownloadAppDevices.includes(device)) {
      setTimeout(() => {
        this.setState(() => ({
          isAppDownloadPromptDisplayed: true,
        }))

        trackAppDownloadPrompt()
      }, 3000)
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  render() {
    const {
      device,
      trackWelcomeAppPromoClick,
      orderId,
      isSignUpFirstTwoBoxesExperimentEnabled,
    } = this.props

    const { isAppDownloadPromptDisplayed } = this.state

    if (isSignUpFirstTwoBoxesExperimentEnabled) {
      return (
        <div data-testid="beetroots_1_2_orders">
          <WelcomeFirstBoxOrderWrapper
            isSignUpFirstTwoBoxesExperimentEnabled={isSignUpFirstTwoBoxesExperimentEnabled}
          />
          <AwinPixelContainer orderId={orderId} />
          {isAppDownloadPromptDisplayed && <AppDownloadPrompt device={device} />}
        </div>
      )
    } else {
      return (
        <section className={css.container} data-testid="welcomeContainer">
          <div className={classnames(css.contentContainer)}>
            <div className={css.row}>
              <div className={css.colMedium}>
                <div className={css.welcomeColInnerContainer}>
                  <OrderSchedule />
                  <div className={classnames(css.welcomeColInner, css.appPromo)}>
                    <AppPromo
                      device={device}
                      trackWelcomeAppPromoClick={trackWelcomeAppPromoClick}
                    />
                  </div>
                </div>
                <div className={classnames(css.welcomeColInner, css.mobileShow, css.rafMobile)}>
                  <ReferAFriend />
                </div>
              </div>
              <div className={classnames(css.colSmall, css.mobileHide)}>
                <div className={classnames(css.welcomeColInner, css.orderSummaryWrapper)}>
                  <OrderSummary />
                </div>
                <div className={classnames(css.welcomeColInner)}>
                  <ReferAFriend />
                </div>
              </div>
            </div>
          </div>
          <AwinPixelContainer orderId={orderId} />
          {isAppDownloadPromptDisplayed && <AppDownloadPrompt device={device} />}
        </section>
      )
    }
  }
}

Welcome.propTypes = propTypes

export { Welcome }
